import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers'

export function makeCredentialsProvider(idToken: string) {
  return fromCognitoIdentityPool({
    identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
    clientConfig: { region: import.meta.env.VITE_AWS_REGION },
    logins: {
      'accounts.google.com': idToken,
    },
  })
}
